module.exports = __webpack_public_path__ + "img/Group 35.69d1323c.png";